<template>
    <div>
    <main class="main">
            <div class="bredcumb">
                <div class="container">
                    <ul>
                        <li><router-link to="/index"><a href="/index">首頁</a></router-link></li>
                        <li>訊息</li>
                    </ul>
                </div>
            </div>

            <!--我的帳戶開始-->

          
            <!-- 會員專區專用header end-->

            <div class="bodyContent user">
                <div class="container">
                    <div class="row no-gutters">
                        
                        <section class="emptyPage">
                            <div class="wrap">
                                <figure>
                                    <img src="@/assets/images/status_login.png" alt="登入">
                                    <figcaption>
                                        為了您的帳戶安全，請您先登入
                                    </figcaption>
                                </figure>
                                  <div class="udnLogin">
                                    <a class="btnStyle_2 unlogin" href="javascript:;"><span>登入</span></a>
                                 </div>
                            </div>
                        </section>
                        
                    </div>
                </div>
            </div>
        
            <!--我的帳戶結束-->

        </main>
        
    </div>    
</template>

<script>
import { mapGetters } from "vuex";

export default {
     name: 'async',
    metaInfo () {
      return {
        
        title: '訊息 | 一刻鯨選',
        meta: [
            // OpenGraph data (Most widely used)
            {property: 'og:title', content: '訊息 | 一刻鯨選'},
            {property: 'og:site_name', content: '訊息 | 一刻鯨選'},
            // The list of types is available here: http://ogp.me/#types
            {property: 'og:type', content: 'website'},
            // Should the the same as your canonical link, see below.
            {property: 'og:url', content: window.location.toString()},
            {property: 'og:image', content: this.$store.state.urlDomain+'/static/logo.jpg'},
            // Often the same as your meta description, but not always.
            {property: 'og:description', content: '一刻鯨選，行動新課堂，15分鐘聆聽新知，深入淺出，充實每一刻！打破學習框架，隨選隨聽，商管投資、文史賞析、生活陶冶，療癒心靈、充實大腦，浩瀚知識洋，即刻探索！'},
        
        ]
      }
    },
  
 data() {
    return {
       classData: [],
    }
  },
  computed: {

    ...mapGetters([
      "userInfo",

      // ...
    ])
  },
 methods: {
       

　　},
    created(){
        if(this.userInfo.id != null){
             this.$router.push({ path: '/index', params: {  } });
        }

    },
    mounted() {
        $(".udnLogin").click(function(){
            $('.login').fadeIn(200).css('display','flex');
            $('body, .bodyWrapper').addClass('overflowhidden');
            return false;
         });

      }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/views/Msg.vue